module.exports = __webpack_public_path__ + "img/202309_01.091a9e82.jpg";